export default "__VITE_ASSET__31fT$oWF__"